import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { isPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { ellipsis } from 'Components/DashboardTile/TileContentMaker/components/common/commonStyles';
import { sortDocumentsDescending } from 'Utility/documentHandling';
import type { IEngelClassification } from 'neuro-schemas/epilepsySurgicalTreatment';

const Treatment = ({ document }: { document: IEpilepsySurgicalTreatment }): React.JSX.Element => (
  <React.Fragment>
    <div>
      {document.operations?.[0] ? (
        <>
          {document.operations[0].typeOfOperation ? (
            <FormattedMessage
              id={`surgicalTreatment.operation.typeOfOperation.opts.${document.operations[0].typeOfOperation}`}
            />
          ) : (
            '-'
          )}
        </>
      ) : (
        '-'
      )}
      {document.operations?.[1] ? (
        <>
          {' / '}
          {document.operations[1].typeOfOperation ? (
            <FormattedMessage
              id={`surgicalTreatment.operation.typeOfOperation.opts.${document.operations[1].typeOfOperation}`}
            />
          ) : (
            '-'
          )}
        </>
      ) : (
        ''
      )}
    </div>
  </React.Fragment>
);

const EngelClassification = ({ document }: { document: IEngelClassification | undefined }): React.JSX.Element => (
  <React.Fragment>
    <div>
      {document ? (
        <>
          <div>
            {document.date ? <div>{formatPartialDate(document.date)}</div> : ''}
            {document.classification ? (
              <div style={ellipsis(25)}>
                <FormattedMessage
                  id={`surgicalTreatment.engelClassification.class${document.classification.slice(1)}.opts.${
                    document.classification
                  }`}
                />
              </div>
            ) : (
              ''
            )}
          </div>
        </>
      ) : (
        '-'
      )}
    </div>
  </React.Fragment>
);

const SurgicalTreatmentDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const lastSurgicalTreatment = documents
    .filter(d => isPartialDate(d.date))
    .sort(sortDocumentsDescending)
    .at(0);

  return (
    <TileContentMaker
      type="bigHeaderInfo"
      bigHeaderText={lastSurgicalTreatment ? <Treatment document={lastSurgicalTreatment} /> : null} // is this null here what we want
      bigHeaderTextSubheader={<FormattedMessage id={'surgicalTreatment.operation.operation'} />}
      data={[
        {
          title: <FormattedMessage id="general.date" />,
          value: isPartialDate(lastSurgicalTreatment?.date) ? formatPartialDate(lastSurgicalTreatment.date) : null,
          key: 'date',
        },
        {
          title: <FormattedMessage id={'surgicalTreatment.engelClassification.title'} />,
          value: <EngelClassification document={lastSurgicalTreatment?.engelClassification?.at(0)} />,
          key: 'engel',
        },
      ]}
    />
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'epilepsySurgicalTreatment'>[];
}

export default SurgicalTreatmentDash;
